// extracted by mini-css-extract-plugin
export default {"lockView":"CustomCell_lockView__epjq2","mainContainer":"CustomCell_mainContainer__52ZIc"};